

/** Shipping Offer Notice Start */
async function CustomGetCart() {
  try {
    const response = await fetch(window.Shopify.routes.root + 'cart.js');
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const cart = await response.json();
    return cart;
  } catch (error) {
    console.error('Error fetching cart:', error);
  }
}

document.body.addEventListener('cstmCartUpdated', async function () {
    const cart = await CustomGetCart();
    if(cart.item_count > 0)
    {
        if(cart.total_price >= 3500){
            output = ' <span class="eligible_icon">You are QUALIFIED for free shipping.</span> ';
        }else{
            var left = (parseInt(3500) - parseInt(cart.total_price)) / 100;
            var mainleft = left.toFixed(2);
            output = '<span class="pending_amount"> You have $'+mainleft+' left to get free shipping.</span>';
        }
        
        $('div.free_shipping_wrap').html(output);
        $('div.section-topbar__message .ktest').html(output);

    }
});
/** Shipping Offer Notice End */